module.exports = __webpack_public_path__ + "static/img/comma.43e0a867.svg";